import { AxiosInstance } from "../../axios/axiosInstance"
import { apiRoutes } from "../../utils/ApiRoutes"
import { IPagination } from "./AdminApis/AdminDataApi"

export const initiateEjectApi = async (payload: { business_id: string, recipient_email: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.initiateEject, payload)
    return response?.data
}

export const ejectHistoryApi = async (data: IPagination) => {
    const response = await AxiosInstance.post(apiRoutes?.ejectHistory, data)
    return response
}

export const cancelEjectApi = async (payload: { business_id: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.cancelEject, payload)
    return response?.data
}

export const resenedEjectEmailApi = async (payload: { business_id: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.resendEjectEmail, payload)
    return response.data
}

export const acceptEjectApi = async (payload: { token: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.acceptEject, payload)
    return response.data
}

export const rejectEjectApi = async (payload: { token: string, reject_reason: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.rejectEject, payload)
    return response.data
}

export const ejectDetailsApi = async (payload: { token: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.ejectDetails, payload)
    return response.data
}
